import { useState } from "react";
import Button from "~/components/ui/Button";
import Icon from "~/components/ui/Icon";
import { useCart } from "~/hooks/useCart";
import { buildShareUrl } from "~/utils/shareCart";

// Lê o `orderFormId` direto do `useCart()` (em vez de receber por prop) pra
// poder ser renderizado de qualquer lugar — inclusive no cabeçalho do
// drawer (`Drawers.tsx`), que não tem acesso ao carrinho por props, sem
// precisar encadear `orderFormId` por 3 componentes.
function ShareCartButton() {
  const { cart } = useCart();
  const [copied, setCopied] = useState(false);
  const orderFormId = cart.value?.orderFormId;

  if (!orderFormId) return null;

  const url = buildShareUrl(orderFormId, globalThis.location?.origin ?? "");

  const handleShare = async () => {
    if (typeof navigator !== "undefined" && typeof navigator.share === "function") {
      try {
        await navigator.share({ url, title: "Meu carrinho na Daniela Tombini" });
        return;
      } catch {
        // Usuário cancelou o menu nativo — cai pro fallback de copiar.
      }
    }

    if (typeof navigator !== "undefined" && navigator.clipboard) {
      try {
        await navigator.clipboard.writeText(url);
        setCopied(true);
        setTimeout(() => setCopied(false), 3000);
      } catch (err) {
        console.error("[ShareCartButton] falha ao copiar link:", err);
      }
    }
  };

  return (
    <div className="flex items-center gap-1">
      <Button
        aria-label="Compartilhar carrinho"
        className="btn btn-ghost btn-sm flex items-center gap-1"
        onClick={handleShare}
      >
        <Icon id="Share" size={16} strokeWidth={1.5} />
        <span className="text-xs">Compartilhar</span>
      </Button>
      {copied && <span className="text-xs text-base-300">Link copiado!</span>}
    </div>
  );
}

export default ShareCartButton;
